/*!
 * Stimpack - Utilities
 *
 * @author: Matthias Courville
 */


/*!
 * spIsBase64
 * @version : 1.0
 */
export const spIsBase64 = function(string) {

    if (typeof string == 'string')
    {
        if (string.substring(string.length - 1) === '=')
        {
            return true;
        }

        var regex = new RegExp('^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$');

        if (regex.test(string))
        {
            return true;
        }
    }

    return false;
};

export const spBase64Encode = function(str) {

    if (window.btoa) // Internet Explorer 10 and above
        return window.btoa(unescape(encodeURIComponent( str )));
    else
    {
        // Cross-Browser Method (compressed)

        // Create Base64 Object
        var Base64={_keyStr:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",encode:function(e){var t="";var n,r,i,s,o,u,a;var f=0;e=Base64._utf8_encode(e);while(f<e.length){n=e.charCodeAt(f++);r=e.charCodeAt(f++);i=e.charCodeAt(f++);s=n>>2;o=(n&3)<<4|r>>4;u=(r&15)<<2|i>>6;a=i&63;if(isNaN(r)){u=a=64}else if(isNaN(i)){a=64}t=t+this._keyStr.charAt(s)+this._keyStr.charAt(o)+this._keyStr.charAt(u)+this._keyStr.charAt(a)}return t},decode:function(e){var t="";var n,r,i;var s,o,u,a;var f=0;e=e.replace(/[^A-Za-z0-9\+\/\=]/g,"");while(f<e.length){s=this._keyStr.indexOf(e.charAt(f++));o=this._keyStr.indexOf(e.charAt(f++));u=this._keyStr.indexOf(e.charAt(f++));a=this._keyStr.indexOf(e.charAt(f++));n=s<<2|o>>4;r=(o&15)<<4|u>>2;i=(u&3)<<6|a;t=t+String.fromCharCode(n);if(u!=64){t=t+String.fromCharCode(r)}if(a!=64){t=t+String.fromCharCode(i)}}t=Base64._utf8_decode(t);return t},_utf8_encode:function(e){e=e.replace(/\r\n/g,"\n");var t="";for(var n=0;n<e.length;n++){var r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r)}else if(r>127&&r<2048){t+=String.fromCharCode(r>>6|192);t+=String.fromCharCode(r&63|128)}else{t+=String.fromCharCode(r>>12|224);t+=String.fromCharCode(r>>6&63|128);t+=String.fromCharCode(r&63|128)}}return t},_utf8_decode:function(e){var t="";var n=0;var r=c1=c2=0;while(n<e.length){r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r);n++}else if(r>191&&r<224){c2=e.charCodeAt(n+1);t+=String.fromCharCode((r&31)<<6|c2&63);n+=2}else{c2=e.charCodeAt(n+1);c3=e.charCodeAt(n+2);t+=String.fromCharCode((r&15)<<12|(c2&63)<<6|c3&63);n+=3}}return t}}
        // Encode the String
        return Base64.encode(unescape(encodeURIComponent( str )));
    }
};


export const spBase64Decode = function(str) {

    if (window.atob) // Internet Explorer 10 and above
        return decodeURIComponent(escape(window.atob( str )));
    else
    {
        // Cross-Browser Method (compressed)

        // Create Base64 Object
        var Base64={_keyStr:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",encode:function(e){var t="";var n,r,i,s,o,u,a;var f=0;e=Base64._utf8_encode(e);while(f<e.length){n=e.charCodeAt(f++);r=e.charCodeAt(f++);i=e.charCodeAt(f++);s=n>>2;o=(n&3)<<4|r>>4;u=(r&15)<<2|i>>6;a=i&63;if(isNaN(r)){u=a=64}else if(isNaN(i)){a=64}t=t+this._keyStr.charAt(s)+this._keyStr.charAt(o)+this._keyStr.charAt(u)+this._keyStr.charAt(a)}return t},decode:function(e){var t="";var n,r,i;var s,o,u,a;var f=0;e=e.replace(/[^A-Za-z0-9\+\/\=]/g,"");while(f<e.length){s=this._keyStr.indexOf(e.charAt(f++));o=this._keyStr.indexOf(e.charAt(f++));u=this._keyStr.indexOf(e.charAt(f++));a=this._keyStr.indexOf(e.charAt(f++));n=s<<2|o>>4;r=(o&15)<<4|u>>2;i=(u&3)<<6|a;t=t+String.fromCharCode(n);if(u!=64){t=t+String.fromCharCode(r)}if(a!=64){t=t+String.fromCharCode(i)}}t=Base64._utf8_decode(t);return t},_utf8_encode:function(e){e=e.replace(/\r\n/g,"\n");var t="";for(var n=0;n<e.length;n++){var r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r)}else if(r>127&&r<2048){t+=String.fromCharCode(r>>6|192);t+=String.fromCharCode(r&63|128)}else{t+=String.fromCharCode(r>>12|224);t+=String.fromCharCode(r>>6&63|128);t+=String.fromCharCode(r&63|128)}}return t},_utf8_decode:function(e){var t="";var n=0;var r=c1=c2=0;while(n<e.length){r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r);n++}else if(r>191&&r<224){c2=e.charCodeAt(n+1);t+=String.fromCharCode((r&31)<<6|c2&63);n+=2}else{c2=e.charCodeAt(n+1);c3=e.charCodeAt(n+2);t+=String.fromCharCode((r&15)<<12|(c2&63)<<6|c3&63);n+=3}}return t}}
        // Encode the String
        return decodeURIComponent(escape(Base64.decode( str )));
    }
};

// -------------------------------------------------------------------------- //
// URLs
// -------------------------------------------------------------------------- //

/*!
 * spIsExternalUrl
 * @version : 1.0
 */
export const spIsExternalUrl = function(url) {

    var match = url.match(/^([^:\/?#]+:)?(?:\/\/([^\/?#]*))?([^?#]+)?(\?[^#]*)?(#.*)?/);
    if (typeof match[1] === "string" && match[1].length > 0 && match[1].toLowerCase() !== location.protocol) return true;
    if (typeof match[2] === "string" && match[2].length > 0 && match[2].replace(new RegExp(":("+{"http:":80,"https:":443}[location.protocol]+")?$"), "") !== location.host) return true;
    return false;
};

// -------------------------------------------------------------------------- //
// Anchors
// -------------------------------------------------------------------------- //

/*!
 * spGetAnchorFromString
 * @version : 1.0
 */
export const spGetAnchorFromString = function(string) {

    if (string.length > 1 && string.indexOf("#") > -1 && ('#' === string.charAt(0) || '/' === string.charAt(0) || !spIsExternalUrl(string)))
    {
        return string.substr(string.indexOf("#"));
    }
};

/*!
 * spGetAnchorTarget
 * @version : 1.0
 */
export const spGetAnchorTarget = function(string) {

    if (string instanceof jQuery)
    {
        string = (string.length > 0) ? string.data('sp-anchor-target') || string.attr('href') : '';
    }

    var target = spGetAnchorFromString(string);

    if (target)
    {
        target = jQuery(target);

        if (target.length > 0)
        {
            return target;
        }
    }
};

// -------------------------------------------------------------------------- //
// Breakpoints
// -------------------------------------------------------------------------- //

/*!
 * spIsBreakpointReached
 * @version : 1.0
 */
export const spIsBreakpointReached = function(breakpoint) {

    if (typeof breakpoint === 'string')
    {
        switch(breakpoint)
        {
            case 'sm-down'  : breakpoint = STIMPACK.breakpoints.sm * -1; break;
            case 'sm-up'    :
            case 'sm'       : breakpoint = STIMPACK.breakpoints.sm; break;

            case 'md-down'  : breakpoint = STIMPACK.breakpoints.md * -1; break;
            case 'md-up'    :
            case 'md'       : breakpoint = STIMPACK.breakpoints.md; break;

            case 'lg-down'  : breakpoint = STIMPACK.breakpoints.lg * -1; break;
            case 'lg-up'    :
            case 'lg'       : breakpoint = STIMPACK.breakpoints.lg; break;

            case 'xl-down'  : breakpoint = STIMPACK.breakpoints.xl * -1; break;
            case 'xl-up'    :
            case 'xl'       : breakpoint = STIMPACK.breakpoints.xl; break;

            default : breakpoint = 0;
        }
    }

    if (breakpoint >= 0 && jQuery(window).width() >= breakpoint)
    {
        return true;
    }
    else if (breakpoint < 0 && jQuery(window).width() < breakpoint)
    {
        return true;
    }

    return false;
};


// -------------------------------------------------------------------------- //
// Elements
// -------------------------------------------------------------------------- //

export const spTryToGetElement = function(selector)
{
    try
    {
        return jQuery(selector);
    }
    catch(err)
    {
        console.log('Not a valid selector: ', selector);
    }

    return [];
};

export const spTryToGetAncestor = function(source, selector)
{
    source = spTryToGetElement(source);

    if (source.length > 0)
    {
        try
        {
            return source.closest(selector);
        }
        catch(err)
        {
            console.log('Not a valid selector: ', selector);
        }
    }

    return [];
};

export const spTryToFindElement = function(ancestor, selector)
{
    ancestor = spTryToGetElement(ancestor);

    if (ancestor.length > 0)
    {
        try
        {
            return ancestor.find(selector);
        }
        catch(err)
        {
            console.log('Not a valid selector: ', selector);
        }
    }

    return [];
};

export const spGetElement = function(o)
{
    var el;

    if (typeof o === 'function')
    {
        el = o.call(this);
    }
    else if (typeof o === 'object' && (o.selector || o.ancestor))
    {
        if (o.ancestor)
        {
            var ancestor = Array.isArray(o.ancestor) ? spTryToGetAncestor(o.ancestor[0], o.ancestor[1]) : spTryToGetElement(o.ancestor);

            if (ancestor.length > 0)
            {
                el = o.selector ? spTryToFindElement(ancestor, o.selector) : ancestor;
            }
        }
        else
        {
            el = spTryToGetElement(o.selector);
        }
    }
    else
    {
        el = typeof window[o] === 'function' ? window[o].call(this) : spTryToGetElement(o);
    }

    return (el instanceof jQuery) ? el : [];
};

export const spGetElementAttribute = function(o, attribute)
{
    var el = spGetElement(o);

    if (el.length > 0)
    {
        if ('html' === attribute)
        {
            return el.html();
        }
        else
        {
            return el.attr(attribute);
        }
    }
};

// -------------------------------------------------------------------------- //
// Condition
// -------------------------------------------------------------------------- //

export const spCompare = function(a, o, b)
{
    switch (o)
    {
        case '==':
            return a == b;
        case '===':
            return a === b;
        case '!=':
            return a != b;
        case '!==':
            return a !== b;

        case '<':
            return a < b;
        case '>':
            return a > b;
        case '<=':
            return a <= b;
        case '>=':
            return a >= b;

        // TODO 'IN', 'NOT IN', etc....

        default:
            return false;
    }
};

export const spVerifyCondition = function(o)
{
    if (typeof o === 'function')
    {
        return true === o.call(this) ? true : false;
    }
    else if (typeof o === 'string')
    {
        if (typeof window[o] === 'function')
        {
            return true === window[o].call(this) ? true : false;
        }
    }
    else if (typeof o === 'object')
    {
        if (o.relation)
        {
            var verified = false;

            if ('OR' === o.relation)
            {
                $.each(o, function(i, _o) {

                    if ('relation' !== i && true === spVerifyCondition.call(this, _o))
                    {
                        verified = true;
                        return;
                    }
                });
            }
            else
            {
                $.each(o, function(i, _o) {

                    if ('relation' !== i)
                    {
                        return spVerifyCondition.call(this, _o);
                    }
                });
            }

            return verified;
        }
        else
        {
            var a = spVerifyConditionParseValue.call(this, o[0]),
                b = o[2] ? spVerifyConditionParseValue.call(this, o[2]) : '',
                operator = o[1];

            switch (operator)
            {
                case 'is':
                    return (a instanceof jQuery && a.length > 0) ? a.is(b) : false;
                case 'hasClass':
                    return (a instanceof jQuery && a.length > 0) ? a.hasClass(b) : false;
                case 'exists':
                    return (a instanceof jQuery && a.length > 0) ? true : false;
                default:
                    return spCompare(a, operator, b);
            }
        }
    }

    return false;
};

export const spVerifyConditionParseValue = function(o)
{
    if (typeof o === 'function')
    {
        return o.call(this);
    }
    if (typeof o === 'object' && o.attribute)
    {
        return spGetElementAttribute.call(this, o, o.attribute);
    }
    else
    {
        var el = spGetElement.call(this, o);

        if (el.length > 0)
        {
            return el;
        }
    }

    return o;
};
